import React, { useState } from "react";
import { ArrowUpRight, ChevronDown, Plus } from "lucide-react";
import { PageShell } from "../components/Layout";
import "./Faq.css";
const faqs = [
  [
    "What is The Bryan Residence?",
    "The Bryan Residence is a collection of luxury automated three-bedroom holiday apartments in Lekki Phase 1, Lagos. Each apartment offers a unique design, premium amenities and modern comforts.",
  ],
  [
    "How many apartments are available?",
    "Five unique apartments are available: Study Apartment, Story Apartment, Silver Screen Apartment, Odeon Apartment and Disco Flame Apartment.",
  ],
  [
    "How much does it cost to stay?",
    "Rates start from ₦300,000 per night, per apartment. A refundable caution fee of ₦100,000 applies to every reservation. Rates may vary by apartment, stay duration, season and special occasions.",
  ],
  [
    "Are the apartments automated?",
    "Yes. All apartments are fully automated, incorporating smart technology for a more comfortable, convenient and seamless stay.",
  ],
  [
    "Are all apartments three-bedroom apartments?",
    "Yes. All five residences are spacious three-bedroom apartments, thoughtfully designed for comfortable luxury living.",
  ],
  [
    "Do all apartments have private cinemas?",
    "No. Private cinemas are available in the Study, Silver Screen, Odeon and Disco Flame Apartments. The Story Apartment offers a private jacuzzi and private terrace instead.",
  ],
  [
    "Which apartment has a private jacuzzi?",
    "The Story Apartment features a private jacuzzi and a private terrace for relaxing outdoor moments.",
  ],
  [
    "Which apartment has a private bar?",
    "The Disco Flame Apartment features a private bar area for relaxing, drinks and memorable social moments.",
  ],
  [
    "Does The Bryan Residence have a swimming pool?",
    "Yes. Guests have access to a swimming pool within the residence.",
  ],
  [
    "Is there a gym and restaurant?",
    "Yes. The Bryan Residence features a fitness gym and restaurant services for guests.",
  ],
  [
    "Are electricity and Wi-Fi available?",
    "Yes. We provide 24-hour electricity and high-speed Wi-Fi throughout your stay.",
  ],
  [
    "Are housekeeping, security and parking available?",
    "Yes. Professional housekeeping, 24-hour security and dedicated guest parking are available.",
  ],
  [
    "Where is The Bryan Residence located?",
    "42 Olanrewaju Ninalowo Crescent, Off Kafayat Abdulrazak Street, Lekki Phase 1, Lagos, Nigeria — close to restaurants, shopping, beaches, entertainment and business districts.",
  ],
  [
    "Who can stay at The Bryan Residence?",
    "Our apartments are ideal for couples, families, groups, business travelers and guests seeking a premium holiday or extended stay in Lagos.",
  ],
  [
    "Can I host a celebration or stay for more than one night?",
    "Special occasions may be accommodated subject to apartment availability, guest numbers and house rules. Extended stays are welcome; contact reservations for applicable rates.",
  ],
  [
    "How do I make a reservation?",
    "Contact our reservations team with your preferred apartment and stay dates. We will confirm availability, share the applicable rate and guide you through booking.",
  ],
  [
    "Can I choose a specific apartment?",
    "Yes, subject to availability. We recommend booking in advance for peak periods and special occasions.",
  ],
  [
    "Is the caution fee refundable?",
    "Yes. The ₦100,000 caution fee is refundable, subject to the residence’s applicable terms and conditions.",
  ],
];
export default function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <PageShell>
      <main className="faq container">
        <section className="faq__hero">
          <div>
            <p className="eyebrow">Frequently asked questions</p>
            <h1>
              Everything you need
              <br />
              <em>before your stay.</em>
            </h1>
            <p>
              Planning your stay at The Bryan Residence? Find answers to
              questions our guests ask most often. Our reservations team is
              always happy to assist.
            </p>
            <a href="#answers">
              Browse answers <ArrowUpRight size={15} />
            </a>
          </div>
          <aside>
            <span>₦</span>
            <b>
              Luxury stays,
              <br />
              made clear.
            </b>
            <p>
              From rates and apartment features to special requests, every
              detail is here.
            </p>
          </aside>
        </section>
        <section className="faq__answer-grid" id="answers">
          <article className="faq__contents">
            <p>The Bryan Residence</p>
            <a href="#answers">
              <span>01</span>Before booking
              <ArrowUpRight size={13} />
            </a>
            <a href="#answers">
              <span>02</span>Apartments & amenities
              <ArrowUpRight size={13} />
            </a>
            <a href="#answers">
              <span>03</span>Reservations
              <ArrowUpRight size={13} />
            </a>
          </article>
          {faqs.map(([q, a], i) => (
            <article
              key={q}
              className={`faq__question ${open === i ? "faq__question--open" : ""}`}
            >
              <span>{String(i + 1).padStart(2, "0")}</span>
              <button onClick={() => setOpen(open === i ? -1 : i)}>
                <h2>{q}</h2>
                <Plus size={18} />
              </button>
              {open === i && <p>{a}</p>}
            </article>
          ))}
        </section>
        <section className="faq__help">
          <p>Still have questions?</p>
          <h2>
            Our team is happy to help with special requests, availability and
            reservations.
          </h2>
          <div>
            <a href="/contact">
              Contact us <ArrowUpRight size={14} />
            </a>
            <a href="/accommodation">
              Book now <ArrowUpRight size={14} />
            </a>
          </div>
        </section>
      </main>
    </PageShell>
  );
}
